import { render, staticRenderFns } from "./currencymod.vue?vue&type=template&id=21bfc4bc&"
import script from "./currencymod.vue?vue&type=script&lang=js&"
export * from "./currencymod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21bfc4bc')) {
      api.createRecord('21bfc4bc', component.options)
    } else {
      api.reload('21bfc4bc', component.options)
    }
    module.hot.accept("./currencymod.vue?vue&type=template&id=21bfc4bc&", function () {
      api.rerender('21bfc4bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2y5ZoDM6J7kvH/JS/comp/currencymod.vue"
export default component.exports